const actionType = {
    GET_REPORT:'GET_REPORT',
    GET_REPORT_SUCCESS:'GET_REPORT_SUCCESS',
    GET_REPORT_FAILURE:'GET_REPORT_FAILURE',
    SET_SESSION_DATA:'SET_SESSION_DATA'
}
export default actionType 